/* global axios */

import ApiClient from './ApiClient';

class IntegrationsAPI extends ApiClient {
  constructor() {
    super('integrations/apps', { accountScoped: true });
  }

  connectSlack(code) {
    return axios.post(`${this.baseUrl()}/integrations/slack`, { code });
  }

  updateSlack({ referenceId }) {
    return axios.patch(`${this.baseUrl()}/integrations/slack`, {
      reference_id: referenceId,
    });
  }

  listAllSlackChannels() {
    return axios.get(`${this.baseUrl()}/integrations/slack/list_all_channels`);
  }

  delete(integrationId) {
    return axios.delete(`${this.baseUrl()}/integrations/${integrationId}`);
  }

  createHook(hookData) {
    return axios.post(`${this.baseUrl()}/integrations/hooks`, hookData);
  }

  updateHook(hookId, hookData) {
    return axios.patch(
      `${this.baseUrl()}/integrations/hooks/${hookId}`,
      hookData
    );
  }

  deleteHook(hookId) {
    return axios.delete(`${this.baseUrl()}/integrations/hooks/${hookId}`);
  }

  getWhchatV2Configuration() {
    return axios.get(`${this.baseUrl()}/integrations/whchat_v2`);
  }

  updateWhchatV2Configuration(formData) {
    return axios.patch(`${this.baseUrl()}/integrations/whchat_v2`, formData);
  }

  deleteWhchatV2Configuration() {
    return axios.delete(`${this.baseUrl()}/integrations/whchat_v2`);
  }

  getVtigerModules(hookId) {
    return axios.get(
      `${this.baseUrl()}/integrations/hooks/${hookId}/vtiger/modules`
    );
  }

  getVtigerModuleFields(hookId, moduleName) {
    return axios.get(
      `${this.baseUrl()}/integrations/hooks/${hookId}/vtiger/modules/${encodeURIComponent(moduleName)}/fields`
    );
  }

  getWhatsappTemplateManager() {
    return axios.get(
      `${this.baseUrl()}/integrations/whatsapp_template_manager`
    );
  }

  updateWhatsappTemplateManager(channels) {
    return axios.patch(
      `${this.baseUrl()}/integrations/whatsapp_template_manager`,
      { channels }
    );
  }

  updateWhatsappTemplateStorage(storage) {
    return axios.patch(
      `${this.baseUrl()}/integrations/whatsapp_template_manager/storage`,
      { storage }
    );
  }

  syncWhatsappTemplates(channelId) {
    return axios.post(
      `${this.baseUrl()}/integrations/whatsapp_template_manager/sync`,
      { channel_id: channelId }
    );
  }

  createWhatsappTemplate(template) {
    return axios.post(`${this.baseUrl()}/integrations/whatsapp_templates`, {
      template,
    });
  }

  updateWhatsappTemplate(templateId, template) {
    return axios.patch(
      `${this.baseUrl()}/integrations/whatsapp_templates/${templateId}`,
      { template }
    );
  }

  deleteWhatsappTemplate(templateId) {
    return axios.delete(
      `${this.baseUrl()}/integrations/whatsapp_templates/${templateId}`
    );
  }

  submitWhatsappTemplate(templateId) {
    return axios.post(
      `${this.baseUrl()}/integrations/whatsapp_templates/${templateId}/submit`
    );
  }

  connectShopify({ shopDomain }) {
    return axios.post(`${this.baseUrl()}/integrations/shopify/auth`, {
      shop_domain: shopDomain,
    });
  }
}

export default new IntegrationsAPI();
